//populate recent 4 blogs as sub-menu [in qikify add the custom title with class to replace it]
function populateBlogs() {
const dataEl = document.getElementById("latest-blogs-data");
if (!dataEl) return;

const blogs = JSON.parse(dataEl.textContent);

document.querySelectorAll(".menu-blog").forEach((el) => {
    const i = Number(el.dataset.blog) - 1;

    if (!blogs[i]) return;

    el.textContent = blogs[i].title;

    const link = el.closest("a");
    if (link) link.href = blogs[i].url;
});
}

const observer = new MutationObserver(() => {
if (document.querySelector(".menu-blog")) {
    populateBlogs();
    observer.disconnect();
}
});

observer.observe(document.body, {
childList: true,
subtree: true
});